import React, { useEffect, useState } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Bar } from 'react-chartjs-2';
import { Button } from '@mui/material';
import DashFaturamentoDiaMesEmpresaDialog from '../DashFaturamentoDiaMesEmpresaDialog';
import { calcularTamanhoFonte } from '../../../utils/fontSize';
import api from '../../../services/api';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const formatarValor = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    }).format(valor);
};

const Dashboard = ({ isPaused, setIsPaused }) => {

    const [dados, setDados] = useState([]);
    const [modalAberto, setModalAberto] = useState(false);
    const [empresaSelecionado, setEmpresaSelecionado] = useState('');

    useEffect(() => {
        api.get('/faturamentodia_empresa_dash')
            .then(response => setDados(response.data))
            .catch(error => console.error('Erro ao carregar os dados:', error));
    }, []);

    function abrirModal() {
        setModalAberto(true);
        setIsPaused(true);
    }

    function fecharModal() {
        setModalAberto(false);
        // setIsPaused(false);
    }

    const labels = dados.map(item => item.Empresa);

    const dataset = [{
        label: 'DIA',
        data: dados.map(item => item.VlrFatDia),
        backgroundColor: '#1976d2',
        datalabels: {
            anchor: 'end',
            align: 'top',
            color: '#fff',
            font: {
                weight: 'bold',
                size: calcularTamanhoFonte('datalabel')
            },
            formatter: (value) => formatarValor(value)
        }
    },
    {
        label: 'MÊS',
        data: dados.map(item => item.VlrFatMes),
        backgroundColor: '#8A3CE4',
        datalabels: {
            anchor: 'end',
            align: 'bottom',
            color: '#fff',
            font: {
                weight: 'bold',
                size: calcularTamanhoFonte('datalabel')
            },
            formatter: (value) => formatarValor(value)
        }
    }];

    const chartData = {
        labels: labels,
        datasets: dataset
    };

    const chartOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    color: '#fff',
                    font: {
                        size: calcularTamanhoFonte('label')
                    }
                }
            },
            datalabels: {
                anchor: 'end',
                align: 'bottom',
                color: '#fff',
                font: {
                    weight: 'bold',
                    size: calcularTamanhoFonte('datalabel')
                },
                formatter: (value) => formatarValor(value)
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#fff',
                    font: {
                        size: calcularTamanhoFonte('scales')
                    }
                },
                grid: { color: '#444' }
            },
            y: {
                ticks: {
                    color: '#fff',
                    font: {
                        size: calcularTamanhoFonte('scales')
                    }
                },
                grid: { color: '#444' }
            }
        }
    };

    return (
        <div>
            <h1>FATURAMENTO DO DIA/MÊS POR EMPRESA</h1>
            <div style={{ height: '80vh', overflow: 'hidden', padding: '20px', boxSizing: 'border-box', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Bar data={chartData} options={chartOptions} sx={{ mb: 2 }} />
            </div>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                <Button variant="contained" color="success" onClick={abrirModal} style={{ marginTop: '20px' }}>
                    📊 Detalhes de Faturamento
                </Button>
            </div>

            <DashFaturamentoDiaMesEmpresaDialog
                open={modalAberto}
                onClose={fecharModal}
                dados={dados}
                empresaSelecionado={empresaSelecionado}
                setEmpresaSelecionado={setEmpresaSelecionado}
            />

        </div >
    );
};

export default Dashboard;
